"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Munger = exports.getValue = exports.deepMerge = exports.clone = void 0;
var serialize_1 = require("./serialize");
var getValue = function (obj, valuePath) {
    if (valuePath.indexOf(".") === -1) {
        return obj[valuePath];
    }
    var path = valuePath.split(".");
    return path.reduce(function (previous, current) {
        if (previous === undefined || previous === null) {
            return null;
        }
        var data = previous[current];
        if (Array.isArray(previous)) {
            data = previous.map(function (p) {
                return getValue(p, current);
            });
        }
        return data;
    }, obj);
};
exports.getValue = getValue;
var Munger = /** @class */ (function () {
    function Munger(schema) {
        if (schema === void 0) { schema = null; }
        var _this = this;
        this._schema = null;
        this.flatten = function (data) {
            return Object.keys(_this._schema.paths).reduce(function (previous, current) {
                var path = _this._schema.paths[current];
                var _a = path.split("|"), readPath = _a[0], _ = _a.slice(1); // eslint-disable-line
                if (!readPath) {
                    readPath = current;
                }
                previous[current] = getValue(data, readPath);
                return previous;
            }, {});
        };
        this.expand = function (data) {
            var pathedData = Object.keys(_this._schema.paths).reduce(function (previous, current) {
                var value = data[current];
                var path = _this._schema.paths[current];
                var _a = path.split("|"), readPath = _a[0], writePath = _a[1];
                var actualPath = writePath || readPath;
                var paths = actualPath.split(".");
                if (paths.length === 1) {
                    previous[current] = value;
                    return previous;
                }
                paths.reduce(function (previous_, current_, index) {
                    if (index === paths.length - 1) {
                        previous_[current_] = value;
                        return previous_;
                    }
                    if (!previous_[current_]) {
                        previous_[current_] = {};
                    }
                    previous_ = previous_[current_];
                    return previous_;
                }, previous);
                return previous;
            }, {});
            if (!_this._schema.type) {
                return pathedData;
            }
            return (0, serialize_1.deserialize)(_this._schema.type, pathedData);
        };
        this._schema = schema;
    }
    return Munger;
}());
exports.Munger = Munger;
var clone = function (obj) {
    var clone_ = {};
    for (var prop in obj) {
        // eslint-disable-next-line
        if (!obj.hasOwnProperty(prop)) {
            continue;
        }
        if (Array.isArray(obj[prop])) {
            clone_[prop] = obj[prop].map(function (v) { return clone(v); });
        }
        else if (typeof obj[prop] === "object" && obj[prop]) {
            clone_[prop] = clone(obj[prop]);
        }
        else {
            clone_[prop] = obj[prop];
        }
    }
    return clone_;
};
exports.clone = clone;
var deepMerge = function (obj1, obj2, doClone) {
    if (doClone === void 0) { doClone = true; }
    var clonedObject = obj1;
    if (doClone) {
        clonedObject = clone(obj1);
    }
    for (var prop in obj2) {
        // eslint-disable-next-line
        if (!obj2.hasOwnProperty(prop)) {
            continue;
        }
        if (Array.isArray(obj2[prop])) {
            clonedObject[prop] = obj2[prop];
        }
        else if (!!clonedObject[prop] &&
            !!obj2[prop] &&
            typeof clonedObject[prop] === "object" &&
            typeof obj2[prop] === "object") {
            clonedObject[prop] = deepMerge(clonedObject[prop], obj2[prop], false);
        }
        else {
            clonedObject[prop] = obj2[prop];
        }
    }
    return clonedObject;
};
exports.deepMerge = deepMerge;
//# sourceMappingURL=objects.js.map